
// Production Firebase Configuration
const firebaseConfig = {
  apiKey: "AIzaSyDXYk6Hpx_RAXf-21gwKo1gYUD1Xm3MQsc",
  authDomain: "the-pool-app-3e652.firebaseapp.com",
  projectId: "the-pool-app-3e652",
  storageBucket: "the-pool-app-3e652.appspot.com",
  messagingSenderId: "389359518314",
  appId: "1:389359518314:web:ecffb9eb3e0cdf84390013",
  measurementId: "G-WR1V5KG21Z"
};

export default firebaseConfig;
